export function relationEmployeeClassListByTermsQuery(
  employeeId,
  selectedSchoolTerms
) {
  const query = `{relationEmployeeClassListByTerms(employeeId: ${employeeId}, terms: ${JSON.stringify(
    selectedSchoolTerms
  ).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) {id, class{id, name, year, active, studentsQuantity, capacity, updaterId}}}`;
  return query;
}

export function relationEmployeeClassBySchoolClassIdQuery(schoolClassId) {
  const query = `{relationEmployeeClassBySchoolClassId(schoolClassId: ${schoolClassId}) {id, class{id, name, year, active, studentsQuantity, capacity}, employee{id, name}}}`;
  return query;
}

export function employeeTeamClassBySchoolClassId(id) {
  return `{
  relationEmployeeClassBySchoolClassId(schoolClassId: ${id || 0}) {
    id
    employee {
      id
      label
      value
      usuarioChatInterno
      ativo
      pedagogicAdm
      updaterId
      active
      usuarioChat
    }
  }
}
`;
}
